/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {inject} from "@angular/core";
import type {CanDeactivateFn, Routes} from "@angular/router";
import {ArticleCostCategory} from "../../models/pricing/Article";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";
import {VisitCreationData} from "../../services/visit-creation-data";
import type {VisitForm} from "./form/visit-form";

export const visitRoutes = [
  // Inspections
  {
    path: "inspections",
    canActivateChild: [isLoggedIn],
    children: [
      {
        path: "overview",
        loadComponent: () => import("./inspections/overview/inspection-overview").then(m => m.InspectionOverview),
      },
      {
        path: "planner",
        canActivate: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
        loadComponent: () => import("./inspections/planner/inspection-planner").then(m => m.InspectionPlanner),
      },
      {
        path: "reports",
        loadComponent: () => import("./inspections/reports-list/reports-list").then(m => m.ReportsList),
      },
      {
        path: ":inspectionId",
        loadComponent: () => import("./inspections/form/inspection-form").then(m => m.InspectionForm),
      },
    ],
  },

  // Visits
  {
    path: "visits",
    canActivateChild: [isLoggedIn],
    children: [
      {
        path: "",
        loadComponent: () => import("./list/visits-list").then(m => m.VisitsList),
      },
      {
        path: "create",
        canActivate: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
        canDeactivate: [
          ((): boolean => {
            inject(VisitCreationData).clear();
            return true;
          }) as CanDeactivateFn<VisitForm>,
        ],
        loadComponent: () => import("./form/visit-form").then(m => m.VisitForm),
      },
      {
        path: ":visitId",
        children: [
          {
            path: "",
            loadComponent: () => import("./form/visit-form").then(m => m.VisitForm),
          },

          // Costs
          {
            path: "costs",
            canActivateChild: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
            children: [
              {
                path: "create",
                children: [
                  {
                    path: "inspection-cost",
                    loadComponent: () => import("./costs/form/visit-cost-form").then(m => m.VisitCostForm),
                    data: {newCostCategory: ArticleCostCategory.InspectionCosts},
                  },
                  {
                    path: "travel-and-additional-cost",
                    loadComponent: () => import("./costs/form/visit-cost-form").then(m => m.VisitCostForm),
                    data: {newCostCategory: ArticleCostCategory.TravelAndAdditionalCosts},
                  },
                ],
              },
              {
                path: ":visitCostId",
                loadComponent: () => import("./costs/form/visit-cost-form").then(m => m.VisitCostForm),
              },
            ],
          },
        ],
      },
    ],
  },
] as const satisfies Routes;
